// The onboarding tour's view of the canvas — 05k-1 (decision 4: tour.js is kept, with a
// small tourAPI from TS). tour.js stays a plain legacy script, so this goes on
// `window.tourAPI`, where it reads it (fork 2A). main.js's tourAPI, minus the phone's
// bottom sheet (the mobile JS is gone, decision 3). The tour itself is switched off today
// (its startTour only logs), so nothing calls this until it's rebuilt.

import { canvasApi } from "./shell-actions.js";
import { clearWorkspace } from "./presets.js";
import { scrollToTopLeft } from "./canvas-space.js";
import { pixelSize } from "./module-shell.js";
import { getScale, getZoomIdx, setZoom } from "./zoom.js";

export function createTourApi() {
  return {
    /** Pixel x / y, grid cols / rows, as tour.js's layouts give them. */
    createModule: (x: number, y: number, cols: number, rows: number, title: string): HTMLElement =>
      canvasApi().createModule({ x, y, cols, rows, title }),
    clearWorkspace,
    /** Every module gone at once, no animation, no checkpoint — the tour's snapshot
     *  restore (tour.js removed the elements itself, behind React's back). */
    clearModules: () => canvasApi().clearModules(),
    scrollToTopLeft,
    getPixelSize: pixelSize,
    getScale,
    findModule: (title: string): HTMLElement | undefined =>
      [...document.querySelectorAll<HTMLElement>(".placed-module")].find(
        (m) => m.querySelector(".module-title")?.textContent?.trim() === title,
      ),
    refreshModule: (mod: HTMLElement) => canvasApi().refreshModuleBody(mod),
    setZoom,
    getZoomIdx,
  };
}

export type TourApi = ReturnType<typeof createTourApi>;

/** Before tour.js loads (it reads `window.tourAPI` when the tour runs). */
export function installTourApi(): void {
  window.tourAPI = createTourApi();
}
